export const initialFormValues = {
  supplier: '0',
  classification: 'Todos',
  operation: '0',
  origin: 'Todos'
}
